import React from 'react';

import { ILogo } from '../types/ILogo';

const Logo: React.FC<ILogo> = ({ logoSource, height = 60 }) => {
  return (
    <img src={logoSource} height={height} alt='Logo' />
  );
};

export default Logo;
